import React from 'react';

const Features = () => {
  const featureSections = [
    {
      id: 'ai-survey-builder',
      title: 'AI Survey Builder',
      subtitle: 'Create and refine surveys with intelligent assistance',
      image: process.env.PUBLIC_URL + '/img/Features/AI Survey Builder.png',
      layout: 'cardsLeft', // Cards on left, image on right
      features: [
        {
          title: 'Build Surveys with AI',
          description: 'Upload existing surveys or create new ones directly in our platform. Use powerful AI to get new questions or refine current questions.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
            </svg>
          )
        },
        {
          title: 'Test Survey Questions on AI Respondents',
          description: 'Test your survey questions on our AI respondents to get feedback on question design or actual responses to your survey.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          )
        }
      ]
    },
    {
      id: 'automated-report-writer',
      title: 'Automated Report Writer',
      subtitle: 'Generate comprehensive insights and reports instantly',
      image: process.env.PUBLIC_URL + '/img/Features/Automated Report Writer.png',
      layout: 'cardsRight', // Image on left, cards on right
      features: [
        {
          title: 'Insights Analysis',
          description: 'Advanced analytics that interpret survey data to uncover meaningful patterns and insights with automated statistical analysis.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-pink" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z" />
            </svg>
          )
        },
        {
          title: 'Automated Report Generation',
          description: 'Generate comprehensive reports with cross-tables, visualizations, and key insights to support data-driven decision-making.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-pink" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
          )
        }
      ]
    },
    {
      id: 'qualitative-response-analyzer',
      title: 'Qualitative Response Analyzer',
      subtitle: 'Analyze sentiment and message effectiveness with AI',
      image: process.env.PUBLIC_URL + '/img/Features/Qualitative Response Analyzer.png',
      layout: 'cardsLeft', // Cards on left, image on right
      features: [
        {
          title: 'Message Testing',
          description: 'Test different messaging approaches with our synthetic populations. Identify which messages resonate best with your target audience.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
            </svg>
          )
        },
        {
          title: 'Response Analysis',
          description: 'Analyze qualitative responses with advanced sentiment analysis and natural language processing to extract deeper insights.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75-7.478a12.06 12.06 0 014.5 0m-3.75 7.478a12.06 12.06 0 01-4.5 0m8.25-2.472a4.5 4.5 0 00-1.41-8.775 5.25 5.25 0 00-10.233-2.33 3 3 0 00-4.306 4.306A4.5 4.5 0 001.25 15.75v.615a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0020.75 16.5v-.615a4.5 4.5 0 00-1.41-8.775z" />
            </svg>
          )
        }
      ]
    },
    {
      id: 'ai-respondents',
      title: 'AI Respondents',
      subtitle: 'Create synthetic populations that think and respond like real people',
      image: process.env.PUBLIC_URL + '/img/Features/Synthetic Populations.png',
      layout: 'cardsRight', // Image on left, cards on right
      features: [
        {
          title: 'Generate Synthetic Populations',
          description: 'Create AI populations that reflect the demographics of your target audience. Use default U.S. samples or customize your own research population.',
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-pink" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
            </svg>
          )
        },
        {
          title: 'Use AI Respondents',
          description: (
            <>
              Leverage AI respondents to mimic real human behavior. Use them to test surveys, analyze messaging effectiveness, and derive valuable insights.
              <br />
              <a
                href="https://www.humanaiinc.com/blog/ai-twin-project"
                target="_blank"
                rel="noopener noreferrer"
                className="text-pink underline mt-2 inline-block"
              >
                Learn about the AI twin project →
              </a>
            </>
          ),
          icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-pink" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59" />
            </svg>
          )
        }        
      ]
    }
  ];

  const FeatureCard = ({ feature }) => (
    <div className="bg-black/40 backdrop-blur-sm border border-gray-800 p-6 rounded-xl hover:border-pink/50 transition duration-300">
      <div className="mb-4">{feature.icon}</div>
      <h3 className="text-xl font-bold mb-3 text-white">{feature.title}</h3>
      <p className="text-gray-300 text-sm">{feature.description}</p>
    </div>
  );

  const FeatureSection = ({ section, index }) => {
    const isCardsLeft = section.layout === 'cardsLeft';
    
    return (
      <div className={`py-16 ${index > 0 ? 'border-t border-gray-800' : ''}`}>
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            
            {/* Cards Column */}
            <div className={`${isCardsLeft ? 'lg:order-1' : 'lg:order-2'}`}>
              <div className="mb-8">
                <h2 className="text-3xl md:text-4xl font-bold mb-3">
                  <span className="bg-gradient-to-r from-pink to-blue bg-clip-text text-transparent">
                    {section.title}
                  </span>
                </h2>
                <p className="text-lg text-gray-300">{section.subtitle}</p>
              </div>
              
              <div className="space-y-6">
                {section.features.map((feature, featureIndex) => (
                  <FeatureCard key={featureIndex} feature={feature} />
                ))}
              </div>
            </div>

            {/* Image Column */}
            <div className={`${isCardsLeft ? 'lg:order-2' : 'lg:order-1'}`}>
              <div className="relative">
                <img 
                  src={section.image} 
                  alt={section.title}
                  className="w-full h-auto rounded-xl shadow-2xl border border-gray-700"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-pink/10 to-blue/10 rounded-xl pointer-events-none"></div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    );
  };

  return (
    <section id="features" className="py-20 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-pink to-blue bg-clip-text text-transparent">
              Revolutionary Features
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Our AI-powered tools transform how researchers gather and analyze public opinion data
          </p>
        </div>
      </div>

      {/* Feature Sections */}
      <div className="space-y-0">
        {featureSections.map((section, index) => (
          <FeatureSection key={section.id} section={section} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Features; 